import '../utils/appear/appear.js';
import React from 'react';
import './blog.scss';
import dsi18n from '@/i18n/ds';
import { dotSceneNameMap, DotElement } from '@/components/dots';
import { parseImage } from '@/utils/media-transfer';
import { Nav, Shell, Button } from '@alifd/next';
import Avatar from './components/avatar';
import {
  START_DROP_SHIPPING,
  LEARN_DROP_SHIPPING,
  SCALE_YOURS_SCALE,
  FIND_IDEAL,
  SEARCH_PRODUCT,
} from '@/utils/page-links';

const { Item } = Nav;
// 全局声明key
window.i18nPreKey = 'dropshipping-buyercentral';
const Blog = (props: { selected: string }) => {
  return (
    <div className="blog-nav">
      <div className="nav">
        <Shell className="iframe-hack ">
          <Shell.Branding className="head-font">
            <DotElement
              dotType="clk"
              dotParams={{
                scene: dotSceneNameMap.header,
                action: 'header_logo',
              }}
              url={'https://www.alibaba.com/'}>
              <img
                className="saas-logo"
                src={parseImage({
                  img: 'https://img.alicdn.com/imgextra/i2/O1CN01c17gIX1lp8KWzWPJi_!!6000000004867-2-tps-380-52.png',
                })}
              />
            </DotElement>
            <DotElement
              dotType="clk"
              dotParams={{
                scene: dotSceneNameMap.header,
                action: 'header_name',
              }}
              url={SEARCH_PRODUCT}
              className="saas-brand">
              Dropshipping
            </DotElement>
          </Shell.Branding>
          <Shell.Navigation direction="hoz">
            <Nav
              direction="hoz"
              selectedKeys={props.selected}
              className="start-nav"
              type="secondary">
              <Item key={'Learn_DS'} className="start-nav-select">
                <DotElement
                  dotType="clk"
                  dotParams={{
                    scene: dotSceneNameMap.header,
                    action: 'header_menu',
                    key: 'Learn_DS',
                  }}
                  target="_self"
                  url={LEARN_DROP_SHIPPING}>
                  {dsi18n('menu.LearnDropshipping')}
                </DotElement>
              </Item>
              <Item key={'Scale_Your_Sales'} className="start-nav-select">
                <DotElement
                  dotType="clk"
                  dotParams={{
                    scene: dotSceneNameMap.header,
                    action: 'header_menu',
                    key: 'Scale_Your_Sales',
                  }}
                  target="_self"
                  url={SCALE_YOURS_SCALE}>
                  {dsi18n('menu.ScaleYourSales')}
                </DotElement>
              </Item>
              <Item key={'Find_Ideas'} className="start-nav-select">
                <DotElement
                  dotType="clk"
                  dotParams={{
                    scene: dotSceneNameMap.header,
                    action: 'header_menu',
                    key: 'Find_Ideas',
                  }}
                  target="_self"
                  url={FIND_IDEAL}>
                  {dsi18n('menu.FindIdeas')}
                </DotElement>
              </Item>
              <Item key={'StartDropshipping'} className="start-nav-select">
                <DotElement
                  dotType="clk"
                  dotParams={{
                    scene: dotSceneNameMap.header,
                    action: 'header_menu',
                    key: 'StartDropshipping',
                  }}
                  target="_self"
                  url={START_DROP_SHIPPING}>
                  {dsi18n('menu.StartDropshipping')}
                </DotElement>
              </Item>
            </Nav>
          </Shell.Navigation>
          <Shell.Action>
            <Avatar />
            <DotElement
              dotType="clk"
              dotParams={{
                scene: dotSceneNameMap.startDropshipping.headerFee,
                action: 'start_header_fee',
              }}
              url={SEARCH_PRODUCT}>
              <Button type="primary" style={{ marginLeft: 30 }}>
                {dsi18n('headline.Banner.Cta.StartForFree')}
              </Button>
            </DotElement>
          </Shell.Action>
        </Shell>
      </div>
    </div>
  );
};
export default Blog;
